import {
    Box,
    Flex,
    Text,
    Input,
} from "@chakra-ui/react";

import { Search } from "lucide-react";

const SupportHeader = () => {
    return (
        <Flex
            justify="space-between"
            align="start"
        >
            <Box>
                <Text
                    fontSize="30px"
                    fontWeight="700"
                    color="#2453FF"
                >
                    Support & Help Center
                </Text>

                <Text color="gray.500">
                     Get help with recruitment referrals, commission payouts,
                     referral codes, partner account settings, and technical issues.
                </Text>
            </Box>
        </Flex>
    );
};

export default SupportHeader;